import {
  TASK_LIST,
  USER_PAGE,
  WORKLOAD_TABLE,
  FREELANCER_TABLE,
  PROJECT_PAGE,
  CLIENT_TABLE,
  EVENT_TABLE,
  REPORT_PAGE,
  PROJECT_REPORT_PAGE,
  ARTICLE_LIST,
  COMMENT_WIDGET,
  SERVICE_ANALYTICS,
  NAV_BAR,
} from 'constants/SettingConstants';

import moment from 'moment';
import { backendDateFormat } from 'util/config';

export const getDefaultConfigs = (userState) => {
  if (!userState[PROJECT_PAGE]) {
    userState[PROJECT_PAGE] = {
      filters: {
        leader: 'all',
        responsible: 'all',
        manager: 'all',
        status: 'active',
        services: 'all',
        view: 'cards',
      },
      sorting: {
        key: 'name',
        value: 'ascending',
      },
    };
  }

  if (!userState[CLIENT_TABLE]) {
    userState[CLIENT_TABLE] = {
      filters: {
        clientStatus: 'all',
        hasResponsible: null,
      },
    };
  }

  if (!userState[EVENT_TABLE]) {
    userState[EVENT_TABLE] = {
      filters: {
        type: 'all',
        status: 'active',
        scheduled: 'future',
      },
    };
  }

  if (!userState[TASK_LIST]) {
    userState[TASK_LIST] = {
      filters: {
        view: 'list',
      },
      sorting: {
        key: 'priority',
        value: 'descending',
      },
    };
  }

  if (!userState[USER_PAGE]) {
    userState[USER_PAGE] = {
      filters: {
        status: 'active',
        view: 'cards',
      },
    };
  }

  if (!userState[WORKLOAD_TABLE]) {
    userState[WORKLOAD_TABLE] = {
      filters: {
        position: 'all',
        department: 'all',
      },
    };
  }

  if (!userState[FREELANCER_TABLE]) {
    userState[FREELANCER_TABLE] = {
      filters: {
        status: 'active',
        cms: 'all',
      },
    };
  }

  if (!userState[REPORT_PAGE]) {
    userState[REPORT_PAGE] = {
      filters: {
        dateTo: moment().format(backendDateFormat),
        dateFrom: moment()
          .add(-1, 'month')
          .format(backendDateFormat),
        projectId: 'all',
        userId: 'all',
        type: 'default',
      },
    };
  }

  if (!userState[PROJECT_REPORT_PAGE]) {
    userState[PROJECT_REPORT_PAGE] = {};
  }

  if (!userState[ARTICLE_LIST]) {
    userState[ARTICLE_LIST] = {
      sorting: {
        key: 'contentTimeUpdated',
        value: 'descending',
      },
    };
  }

  if (!userState[COMMENT_WIDGET]) {
    userState[COMMENT_WIDGET] = {
      viewType: 'bottom',
      entities: ['responsible', 'labels', 'date'],
    };
  }

  if (!userState[COMMENT_WIDGET].entities) {
    userState[COMMENT_WIDGET].entities = ['responsible', 'labels', 'date'];
  }

  if (!userState[SERVICE_ANALYTICS]) {
    userState[SERVICE_ANALYTICS] = {
      filters: {
        serviceId: null,
        dateFrom: null,
        dateTo: null,
      },
    };
  }

  if (!userState[NAV_BAR]) {
    userState[NAV_BAR] = {
      collapsed: false,
    };
  }

  return { ...userState };
};
